import { render } from "./PartnerMatching.vue?vue&type=template&id=33d7df80&scoped=true"
import script from "./PartnerMatching.vue?vue&type=script&lang=js"
export * from "./PartnerMatching.vue?vue&type=script&lang=js"

import "./PartnerMatching.vue?vue&type=style&index=0&id=33d7df80&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d7df80"]])

export default __exports__